export const VOICIFY_EFFECT_DATA = "voicifyEffectData";
export const VOICIFY_CHAT_STATE = "voicifyChatState";
export const VOICIFY_CHAT_HISTORY = "voicifyChatHistory";
export const VOICIFY_USER_STATE = "voicifyUserState";
export const VOICIFY_AFTER_EFFECT_DATA = "voicifyAfterEffectData";
export const VOICIFY_AFTER_RESPONSE_DATA = "voicifyAfterResponseData";